// ----------------------------------------------------------------------

export default function Divider(theme) {
  return {
    MuiDivider: {
      styleOverrides: {
        root: {
          height: 0,
          backgroundColor: "unset",
        },
      },
    },
  };
}
